<form [formGroup]="form" (ngSubmit)="guardar()" class="flex flex-col h-full">
  <div class="flex-1 overflow-y-auto px-6 py-5 space-y-5">
    @if (error) {
      <div class="rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-500/30 dark:bg-error-500/10 dark:text-error-400">
        {{ error }}
      </div>
    }

    @if (readOnly) {
      <div class="rounded-lg border border-blue-light-200 bg-blue-light-50 px-3 py-2 text-sm text-blue-light-700 dark:border-blue-light-500/30 dark:bg-blue-light-500/10 dark:text-blue-light-400">
        Este es un rol de sistema. Solo se puede consultar; no se puede editar ni eliminar.
      </div>
    }

    <!-- Datos principales -->
    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Nombre <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          formControlName="name"
          maxlength="50"
          placeholder="Ej. Supervisor de ventas"
          class="w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300 disabled:opacity-60 disabled:cursor-not-allowed"
          [class.border-error-400]="hasError('name')"
        />
        @if (hasError('name')) {
          <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ getError('name') }}</p>
        }
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Descripción
        </label>
        <textarea
          formControlName="description"
          rows="2"
          maxlength="255"
          placeholder="Describe brevemente el alcance de este rol..."
          class="w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300 disabled:opacity-60 disabled:cursor-not-allowed"
          [class.border-error-400]="hasError('description')"
        ></textarea>
        @if (hasError('description')) {
          <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ getError('description') }}</p>
        }
      </div>
    </div>

    <!-- Matriz de permisos -->
    <div>
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-200">Matriz de permisos</h3>
        <span class="text-xs text-gray-500 dark:text-gray-400">Módulo × Acción</span>
      </div>

      <p class="mb-2 text-xs text-gray-500 dark:text-gray-400">
        Nota: los permisos <span class="font-medium">Importar</span> y <span class="font-medium">Exportar</span>
        hoy solo tienen efecto en el módulo <span class="font-medium">Contactos</span>; en los demás módulos quedan reservados para uso futuro.
      </p>

      @if (loading) {
        <div class="flex justify-center py-8">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
        </div>
      } @else {
        <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Módulo</th>
                @for (action of actions; track action.key) {
                  <th class="px-2 py-2 text-center font-medium text-gray-600 dark:text-gray-400 w-20">
                    <div class="flex flex-col items-center gap-1">
                      <span>{{ action.label }}</span>
                      <input
                        type="checkbox"
                        [checked]="isColumnFull(action.key)"
                        [disabled]="readOnly"
                        (change)="toggleColumn(action.key, $any($event.target).checked)"
                        title="Marcar toda la columna"
                        class="h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500/30 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700"
                      />
                    </div>
                  </th>
                }
                <th class="px-2 py-2 text-center font-medium text-gray-600 dark:text-gray-400 w-16">Todo</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
              @for (row of rows; track trackRow($index, row)) {
                <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                  <td class="px-3 py-2">
                    <span class="font-medium text-gray-900 dark:text-white">{{ row.moduleName }}</span>
                    @if (row.category) {
                      <span class="ml-2 text-xs text-gray-400 dark:text-gray-500">{{ row.category }}</span>
                    }
                  </td>
                  @for (action of actions; track action.key) {
                    <td class="px-2 py-2 text-center">
                      <input
                        type="checkbox"
                        [checked]="row[action.key]"
                        [disabled]="readOnly"
                        (change)="onCellChange(row, action.key, $any($event.target).checked)"
                        class="h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500/30 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700"
                      />
                    </td>
                  }
                  <td class="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      [checked]="isRowFull(row)"
                      [disabled]="readOnly"
                      (change)="toggleRow(row, $any($event.target).checked)"
                      title="Marcar toda la fila"
                      class="h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500/30 disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700"
                    />
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td [attr.colspan]="actions.length + 2" class="px-3 py-6 text-center text-sm text-gray-500 dark:text-gray-400">
                    No hay módulos disponibles.
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="flex items-center justify-end gap-2 px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
    <app-button variant="outline" type="button" (btnClick)="cancelar()">
      {{ readOnly ? 'Cerrar' : 'Cancelar' }}
    </app-button>
    @if (!readOnly) {
      <app-button variant="primary" type="submit" [disabled]="saving || loading">
        {{ saving ? 'Guardando...' : (isEditing ? 'Guardar cambios' : 'Crear rol') }}
      </app-button>
    }
  </div>
</form>
